var _path, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWheelIconMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 17c0 5.523-4.477 10-10 10s-10-4.477-10-10S14.477 7 20 7s10 4.477 10 10zm-2.5 0c0 1.71-.573 3.287-1.537 4.55l-3.255-3.257c.187-.391.292-.83.292-1.293 0-.463-.105-.902-.292-1.293l3.255-3.256A7.467 7.467 0 0127.5 17zm-6.207 2.708l3.256 3.255A7.467 7.467 0 0120 24.5a7.467 7.467 0 01-4.55-1.537l3.257-3.255c.391.187.83.292 1.293.292.463 0 .902-.105 1.293-.292zM20 14c-.463 0-.902.105-1.293.292l-3.256-3.255a7.466 7.466 0 012.99-1.375L20 12l1.559-2.338a7.466 7.466 0 012.99 1.375l-3.256 3.255A2.988 2.988 0 0020 14zm-2.708 1.707l-3.255-3.256A7.467 7.467 0 0012.5 17c0 1.71.573 3.287 1.537 4.55l3.255-3.257A2.988 2.988 0 0117 17c0-.463.105-.902.292-1.293zM12 31h4l3-2h2l3 2h4l1 1-1 1H12.002l-1-1L12 31z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 16,
    height: 16,
    rx: 4,
    fill: "url(#wheelIconMobile_svg__paint0_linear_19529_133349)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wheelIconMobile_svg__paint0_linear_19529_133349",
    x1: 24,
    y1: 8.151,
    x2: 40,
    y2: 8.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B67D"
  })))));
}

export default SvgWheelIconMobile;